import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'

import BannerInfo from './BannerInfo.js'

/**
 * Shared with the mobile sticky bar mount (StickyContactBar's canariasBanner
 * prop) so both surfaces gate on the exact same rule - a professional ad in
 * Canarias - and never drift into two different conditions.
 */
export const getShowCanariasBanner = ({ad = {}, config, seller = {}} = {}) =>
  config.get('CANARIAS_PROVINCE_IDS').includes(ad.provinceId) && Boolean(seller.isDealer)

/**
 * No wrapper of its own on purpose - it fills ContactCardV2's `canariasBanner`
 * slot, whose contract already forbids one (contracts.js: "an absent banner
 * must emit no DOM node at all"). Square corners are fine: `@adv-mt/ui`'s
 * Panel applies `overflow-hidden` unconditionally (base class, not gated by
 * `rounded`), so sitting as the card's first child already clips this to the
 * card's own border-radius - no radius token needed here.
 */
const ContactPanel = ({ad = {}, seller = {}}) => {
  const {domain} = useSuiContext()
  const showCanariasBanner = getShowCanariasBanner({ad, config: domain.get('config'), seller})

  if (!showCanariasBanner) return null

  return <BannerInfo />
}

ContactPanel.displayName = 'ContactPanel'

ContactPanel.propTypes = {
  ad: PropTypes.shape({
    provinceId: PropTypes.number
  }),
  seller: PropTypes.shape({
    isDealer: PropTypes.bool
  })
}

export default ContactPanel
